import supportArticle from "@faire/web-api--source/routes/support/articles/articleId";
var EXCLUSIVITY_ARTICLE_ID = "19903209185947";
export var EXCLUSIVITY_ARTICLE = supportArticle(EXCLUSIVITY_ARTICLE_ID);
export var ENDING_SOON_DAYS = 90;
export var SIX_MONTHS_DAYS = 180;
export var PROMO_BANNER_ORIGIN;
(function(PROMO_BANNER_ORIGIN) {
    PROMO_BANNER_ORIGIN["MY_BRANDS_CARD"] = "MY_BRANDS_CARD";
    PROMO_BANNER_ORIGIN["MY_BRANDS_HEADER"] = "MY_BRANDS_HEADER";
    PROMO_BANNER_ORIGIN["POST_ORDER"] = "POST_ORDER";
    PROMO_BANNER_ORIGIN["BRAND_PAGE"] = "BRAND_PAGE";
})(PROMO_BANNER_ORIGIN || (PROMO_BANNER_ORIGIN = {}));
export var EXCLUSIVITY_ACTIVATION_EXISTING_AGREEMENT_ERROR = "Exclusivity agreement with brand already exists in retailer's area";
